import { Menu } from './components';

function App() {
  return (
    <div className='App'>
      <section className='section-center'>
        <h3>Nice Cream</h3>
        <Menu />
      </section>
    </div>
  );
}

export default App;
